import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAPIFetchApplicationDocumentations } from '@marketplace/api';

type TinitialDataState = {
  name: string;
  url: string;
  support_description: string;
  licence_url: string;
};
type TdocumentationIDsState = {
  documentation_id: string;
  licence_id: string;
};

type TParamsType = {
  id: string;
};

export const useDocumentationForm = () => {
  const { id } = useParams<TParamsType>();
  const {
    data,
    loaded,
    updateDocumentations,
    fetchDocumentations,
    addDocumentations,
  } = useAPIFetchApplicationDocumentations(id);

  const [initialData, setInitialData] = useState<Partial<TinitialDataState>>(
    {}
  );

  const [documentationsIDs, setDocumentationsIDs] = useState<
    Partial<TdocumentationIDsState>
  >({});

  useEffect(() => {
    if (loaded) {
      setDocumentationsIDs({
        documentation_id: data?.documentations[0]?.id ?? '',
        licence_id: data?.licenses[0]?.id ?? '',
      });

      setInitialData({
        name: data?.documentations[0]?.name ?? '',
        url: data?.documentations[0]?.url ?? '',
        support_description: data?.documentations[0]?.support_description ?? '',
        licence_url: data?.licenses[0]?.url ?? '',
      });
    }
  }, [data]);

  const isNewDocumentation = Boolean(
    !documentationsIDs?.documentation_id && !documentationsIDs?.licence_id
  );


  const transformFormDataToAPI = (formValues: any) => {
    return !documentationsIDs?.documentation_id || !documentationsIDs?.licence_id
      ? {
          documentations:
            formValues.name || formValues.support_description || formValues.url
              ? [
                  {
                    name: formValues.name,
                    support_description: formValues.support_description,
                    url: formValues.url,
                  },
                ]
              : [],

          licenses: formValues.licence_url
            ? [
                {
                  url: formValues.licence_url,
                },
              ]
            : [],
        }
      : {
          documentations:
            documentationsIDs?.documentation_id &&
            (formValues.name ||
              formValues.support_description ||
              formValues.url)
              ? [
                  {
                    id: documentationsIDs?.documentation_id,
                    name: formValues.name,
                    support_description: formValues.support_description,
                    url: formValues.url,
                  },
                ]
              : [],
          licenses:
            documentationsIDs?.licence_id && formValues.licence_url
              ? [
                  {
                    id: documentationsIDs?.licence_id,
                    url: formValues.licence_url,
                  },
                ]
              : [],
        };
  };

  return {
    applicationId: id,
    initialData,
    documentationsIDs,
    fetchDocumentations,
    updateDocumentations,
    setInitialData,
    addDocumentations,
    transformFormDataToAPI,
    loaded,
    isNewDocumentation,
  };
}
